<template>
  <div class="bom">
    <div class="module-header v-center space-between px-3">
      <h1 class="module-name">Bill of Materials</h1>
      <div class="bom-action m flex">
        <button
          v-if="showCreateBom"
          class="btn-bulk-import mr-2"
          @click="isBulkImportModalOpen = true"
        >
          <import-icon className="bulk-import-icon" />
          Bulk Import
        </button>
        <modal
          :open="isBulkImportModalOpen"
          @close="isBulkImportModalOpen = false"
          :closeOnOutsideClick="true"
          title="Bulk Import BOM"
          description="Upload multiple Excel files and map columns to BOM fields"
        >
          <bulk-import-modal-content @close="isBulkImportModalOpen = false" />
        </modal>
        <create-bom v-if="showCreateBom"
         @updatebomlist="updatebomlist"
         :bomlistLength="bomList?.length" />
        <button
          :disabled="!selectedProductCode || bomList.length === 0 "
          @click="gotoBomCompare"
          class="btn btn-black mr-2"
        >
          Compare BOM
        </button>
        <button
          :disabled="!canCompare"
          @click="gotoVersionCompare"
          class="btn btn-black mr-2"
        >
          Compare BOM Version
        </button>
      </div>
    </div>
    <div class="bom-container">
      <transition name="sidebar">
      <div v-show="!showProductCode" class="bom-product-code" :class="{ 'bom-product-code-collapsed': !isSidebarOpen }">
        <product-code-list @handle-sidebar="handleSidebarToggle" />
      </div>
    </transition>
      <div :class="showProductCode ? 'bom-full-width':'bom-content'">
        <router-view />
      </div>
    </div>
  </div>
</template>

<script>
import productCodeList from '@/components/bom/product/productCodeList.vue'
import CreateBom from '../../../components/bom/common/createBom.vue'
import modal from '@/components/common/modal.vue'
import ImportIcon from '@/assets/images/SVGcomponents/ImportIcon.vue'
import BulkImportModalContent from '@/components/bom/common/bulkImportModalContent.vue'
import { mapGetters } from 'vuex'
import { GetAllBomVersionListByBomId } from '@/api'
export default {
  components: { productCodeList, CreateBom, modal, ImportIcon, BulkImportModalContent },
  data () {
    return {
      canCompare: false,
      isSidebarOpen: true,
      bomListSidebar: { isOpen: true }, // Added to persist the BOM-list sidebar open state across route changes
      isBulkImportModalOpen: false
    }
  },
  provide () {
    return {
      bomListSidebar: this.bomListSidebar
    }
  },
  computed: {
    ...mapGetters('productBom', ['selectedBomId', 'selectedProductCode', 'bomList']),
    ...mapGetters(['user', 'collaborator']),
    showProductCode () {
      return ((this.$route.path.includes('/bom') && this.$route.path.includes('/edit')) || (this.$route.path.includes('/bom') && this.$route.path.includes('/new')))
    },
    showCreateBom () {
      return ((this.user.tenantLevelRole === 'ADMIN' ||
      this.user.tenantLevelRole === 'COLLABORATOR' || this.user.tenantLevelRole === 'EDITOR') && !this.collaborator)
    }
  },
  methods: {
    async checkBomCompare () {
      if (this.selectedBomId) {
        const res = await GetAllBomVersionListByBomId(this.selectedBomId)
        this.canCompare = res.bom_versions[0].version_no > 1
      }
    },
    gotoVersionCompare () {
      this.$router.push(`/bom/compare/${this.selectedBomId}`)
    },
    gotoBomCompare () {
      this.$router.push(`/bom/compare/product/${this.selectedProductCode}`)
    },
    setBaseData () {
      const { productCode, bomId } = this.$route.params
      this.$store.dispatch('productBom/setBaseData', {
        product_code: productCode || null,
        bom_id: bomId || null
      })
    },
    updatebomlist () {
      this.$store.dispatch('productBom/getAllBomList')
    },
    handleSidebarToggle () {
      this.isSidebarOpen = !this.isSidebarOpen
    }
  },
  mounted () {
    this.checkBomCompare()
  },
  watch: {
    selectedBomId (newVal) {
      if (newVal) {
        this.checkBomCompare()
      }
    },
    '$route.params.productCode' () {
      this.setBaseData()
    },
    '$route.params.bomId' (val) {
      this.setBaseData()
    },
    '$route.query.bomVersionId' (val) {
      this.$store.dispatch('productBom/bomVersionIdChanged', +val || null)
    }
  },
  created () {
    this.$store.dispatch('productBom/getAllProductCode')
    this.setBaseData()
  }
}
</script>

<style lang="scss" scoped >
.sidebar-enter-active,
.sidebar-leave-active {
  transition: width 0.3s ease, min-width 0.3s ease, opacity 0.3s ease;
  overflow: hidden;
}
.sidebar-enter,
.sidebar-leave-to {
  width: 0 !important;
  min-width: 0 !important;
  opacity: 0;
}

.btn-bulk-import {
  display: flex;
  align-items: center;
  gap: 8px;
  background-color: rgba(47, 128, 255, 0.1);
  color: #2f80ff;
  border: 1px solid rgba(47, 128, 255, 0.2);
  border-radius: 6px;
  padding: 6px 16px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    background-color: rgba(47, 128, 255, 0.15);
  }

  .bulk-import-icon {
    width: 16px;
    height: 16px;
  }
}

.bom {
  height: 100%;

  &-container {
    height: calc(100% - 60px);
    display: flex;
    // padding-top: 10px;
    & > div {
      height: 100%;
    }
  }
  &-product-code {
  width: 20%;
  min-width: 20rem;
  transition: width 0.3s ease, min-width 0.3s ease;

  @media screen and (max-width: 1366px) {
    width: 18%;
    min-width: 10rem;
  }

  &.bom-product-code-collapsed {
    width: 32px;
    min-width: 32px;
  }
}
  &-content {
    width: 85%;
    overflow-y: auto;
    flex: 1;
  }
  &-full-width {
    width: 100%;
  }
}

:deep(.modal-header .main-title) {
  font-size: var(--text-base);
  font-weight: 600;
  color: #333;
}

:deep(.modal-description) {
  font-size: var(--text-s);
  color: #666;
}
</style>
